
export const SET_FIREBASE_USER = "SET_FIREBASE_USER";


const user = (state = null, action) => {
  switch (action.type) {
    case SET_FIREBASE_USER:
       return action.payload;
     
    default:
      return state;
  }
};

export default user;
